import React, { useState, useEffect } from "react";
import { Table, Button, Typography, Modal, Form, Select, message } from "antd";
import "./Styles/Dashboard.css";
import OrderDetailsModal from "./OrderDetailsModal"; // Import the OrderDetailsModal component
import moment from "moment"; // Import Moment library for date formatting

const { Link } = Typography;
const { Option } = Select;
const { confirm } = Modal; // Import Modal.confirm

const Dashboard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [vendorId, setVendorId] = useState(null);

  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);

    if (VendorId) {
      fetchUnshippingOrders(VendorId);
    }
  }, []);

  const fetchUnshippingOrders = async (vendorId) => {
    console.log(vendorId);
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/unshippingorders",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendor_id: vendorId }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch unshipped orders");
      }
      const data = await response.json();

      // Filter out orders that are already assigned (based on order_id)
      console.log("unshippingOrders", data);
      setOrderData(data); // Update orderData state with unassigned orders
    } catch (error) {
      console.error("Error fetching unshipped orders:", error);
      // Handle error state if needed
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "order_id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "orderId",
      render: (text) => (
        <Link onClick={() => handleOrderDetails(text)}>{text}</Link>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "order_date",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Customer Name",
      key: "customer_name",
      render: (text, record) =>
        `${record.shipping_first_name} ${record.shipping_last_name}`,
    },
    {
      title: "Customer Phone",
      dataIndex: "shipping_phone",
      key: "customer_phone",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => showAssignModal2(record)}>
          Ready for Pack
        </Button>
      ),
    },
  ];

  const formatDate = (dateString) => {
    console.log("come");
    // Use Moment.js or JavaScript Date object to format the date
    const formattedDate = moment(dateString).format("DD:MM:YYYY hh:mm A");
    return formattedDate;
  };

  const showAssignModal2 = (record) => {
    confirm({
      title: "Are you sure you want to pack this order?",
      content: `Order ID: ${record.order_id}`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: () => handlePackOrder(record),
    });
  };

  const handlePackOrder = async (record) => {
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/packorder", // Replace with your API endpoint
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: record.order_id,
            vendor_id: vendorId, // Replace with actual vendor_id if dynamic
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to pack order");
      }
      const data = await response.json();
      console.log("Pack Order Response:", data);
      message.success("Order packed successfully");
      // Optionally, refresh the order data or update the UI
      fetchUnshippingOrders(vendorId);
    } catch (error) {
      console.error("Error packing order:", error);
      message.error("Error packing order");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
    form.resetFields();
  };

  const handleOrderDetails = async (orderId) => {
    console.log(vendorId);
    try {
      const response = await fetch("https://app-tl2d3sc25q-uc.a.run.app/api/order_details", {
        method: "POST", // Use POST if you are sending data in the body
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vendorId,
          orderId,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch order details");
      }
      const data = await response.json();
      console.log("Order Details:", data);
      // Display modal with order details
      setSelectedOrder(data); // Store order details in state
      setIsModalVisible(true); // Show modal
    } catch (error) {
      console.error("Error fetching order details:", error);
      // Handle error state if needed
    }
  };

  return (
    <div className="dashboard-container">
      <Table
        columns={columns}
        dataSource={orderData}
        rowKey="order_id"
        scroll={{ x: 1200, y: 500 }}
      />

      <OrderDetailsModal
        visible={isModalVisible}
        order={selectedOrder}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default Dashboard;
